module.exports = __webpack_public_path__ + "img/check_blue.5e47422a.svg";